import React, { Fragment } from 'react';
import './tariff.bar.scss';

const TariffBar = ({ data }) => {

  const { id, duration, remaining } = data;

  const current = duration - remaining;
  const percent = current / duration * 100;
  const daytext = current >= 5 ? "дней" : current > 1 ? "дня" : "день";

  return (

    <div className = "tariffbar flex justify-between items-center">

      <div className = "tariffbar__content">

        { id > 0 
          ? "подписка активна" 
          : <Fragment>знакомство <span className='desktop'>с проектом</span></Fragment> 
        }
        
      </div>

      <div className = "tariffbar__progress">
        <div className = "tariffbar__progress__bar" style = {{ width: `${ percent }%` }} />
      </div>

      <div className = "tariffbar__content">
        <b>{ current }</b> { daytext } из <b>{ duration }</b>
      </div>
      
    </div>

  );

}

export default TariffBar;